// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","461":"b637e9a5","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"a1f0deddbd3560447a9b","293":"3e6574eca885e7842427","461":"acc63e2b683253ff2dc4","518":"c8341cdffea3dfcc23a4","779":"aa68d20c3582da20dd1c"}[chunkId] + ".js";
};